<template>
  <div>
    <dialog-address-coverage
      @close="closeDialog"
      :isVisible="isVisible"
      :title="dialogTitle"
      :coverages="coverages"
    />
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>
            Direcciónes Actuales - Código postal
            <el-input
              v-model="code"
              @change="filter"
              class="postalcode"
              autocomplete="off"
              clearable
              maxlength="5"
            >
            </el-input>
          </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <el-row>
      <!-- Table  -->
      <el-col :span="panelWidth" :offset="2">
        <el-card class="box-card">
          <el-table :data="addresses" style="width: 100%" stripe>
            <el-table-column label="País" align="center" width="180" sortable>
              <template>
                <el-tag effect="plain">MX</el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Estado"
              align="center"
              prop="state"
              width="250"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  {{ props.row.state }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Ciudad"
              align="center"
              prop="city"
              width="250"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  {{ props.row.city }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Código Postal"
              align="center"
              prop="postalCode"
              width="150"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  <strong>{{ props.row.postalCode }}</strong>
                </h4>
              </template>
            </el-table-column>

            <el-table-column
              label="Colonia"
              align="center"
              prop="sector"
              width="250"
              sortable
            >
              <template slot-scope="props">
                <h4 class="size-medium">
                  {{ props.row.sector }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column align="center" label="Coberturas">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  round
                  @click="openDialog(scope.row)"
                  >Abrir
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <!-- END Table  -->
    </el-row>

    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { CSApi } from "@/libraries/api";
import DialogAddressCoverage from "@/components/DialogAddressCoverage";

export default {
  name: "Address",
  components: { DialogAddressCoverage },
  data() {
    return {
      panelWidth: 20,
      addresses: [],
      coverages: [],
      dialogTitle: "Coberturas almacenadas por Carrier",
      isVisible: false,
      code: "",
    };
  },
  methods: {
    async update() {
      try {
        const response = await CSApi().get(
          `/coverage/postalCode?page=1&pageSize=500&all=true`
        );
        if (response) this.addresses = response.data.data;
      } catch (error) {
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },

    async filter() {
      try {
        const response = await CSApi().get(
          `/coverage/postalCode/${this.code}?page=1&pageSize=500&all=true`
        );
        if (response) this.addresses = response.data.data;
      } catch (error) {
        this.$message({
          message: error,
          type: "error",
          duration: 8000,
        });
      }
    },
    closeDialog() {
      this.isVisible = false;
      this.coverages = [];
    },
    openDialog(data) {
      this.coverages = data.services.map((service) => ({
        ...data,
        ...service,
      }));
      this.isVisible = true;
    },
  },
  async created() {
    await this.update();
  },

  computed: {
    ...mapState(["current_user"]),
  },
};
</script>

<style scoped>
h4 {
  margin: 2px;
}

.size-medium {
  font-size: 15px;
  font-weight: 100;
}

pre {
  margin: 0px 30px;
}
.el-select {
  width: 230px;
}
.postalcode {
  display: inline-block !important;
  position: relative !important;
  width: 100px !important;
}
</style>
